import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MomentModule } from 'ngx-moment';
import { OrderModule } from 'ngx-order-pipe';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { AppointmentLogModule } from '../appointment-log/appointment-log.module';
import { ProviderService } from '../reminder-settings/state/provider.service';
import { AppointmentListComponent } from './appointment-list.component';
import { AppointmentListEffects } from './state/appointment-list.effects';
import { AppointmentsListReducer, STORE_FEATURE_KEY_APPOINTMENTS_LIST } from './state/appointment-list.reducers';
import { AppointmentListSelectors } from './state/appointment-list.selectors';
import { AppointmentListService } from './state/appointment-list.service';
import { FeatureFlagsModule } from "../../feature-flag/feature-flag.module";

@NgModule({
  imports: [
    CommonModule,
    TooltipModule.forRoot(),
    DropdownModule,
    TableModule,
    CheckboxModule,
    MultiSelectModule,
    FormsModule,
    StoreModule.forFeature(STORE_FEATURE_KEY_APPOINTMENTS_LIST, AppointmentsListReducer),
    EffectsModule.forFeature([AppointmentListEffects]),
    CollapseModule.forRoot(),
    BsDatepickerModule.forRoot(),
    CalendarModule,
    AppointmentLogModule,
    RouterModule,
    TranslateModule,
    MomentModule,
    InfiniteScrollModule, // NOTE: This is NOT our custom version
    OrderModule,
    FeatureFlagsModule
  ],
  declarations: [
        AppointmentListComponent
    ],
  providers: [
        ProviderService,
        AppointmentListService,
        AppointmentListSelectors
    ],
  exports: [
        AppointmentListComponent
    ]
})
export class AppointmentListModule {
}
